import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './DashBoard.css'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaChevronDown, FaSync, FaTimes, FaStar } from 'react-icons/fa'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import BonusModal from './BonusModal'; 
import NewGamesAnnouncementPopup from './NewGamesAnnouncementPopup';
import api from '../api';

const MySwal = withReactContent(Swal);

const DashboardPage = () => {
  const [bettingAmount, setBettingAmount] = useState(localStorage.getItem('bettingAmount') || '');
  const [audioLanguage, setAudioLanguage] = useState(localStorage.getItem('audioLanguage') || '');
  const [callSpeed, setCallSpeed] = useState(localStorage.getItem('callSpeed') || '');
  const [winningPattern, setWinningPattern] = useState(() => {
    try {
      const stored = localStorage.getItem('winningPattern');
      return stored ? JSON.parse(stored) : ['any'];
    } catch (error) {
      return ['any'];
    }
  });  

  const dropdownStyles = {
    dropdown: {
      position: 'relative',
      width: '100%'
    },
    button: {
      width: '100%',
      padding: '8px 12px',
      backgroundColor: '#475569',
      color: 'white',
      border: 'none',
      textAlign: 'left',
      cursor: 'pointer'
    },
    menu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#475569',
      border: '1px solid #374151',
      borderTop: 'none',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000
    },
    option: {
      padding: '8px 12px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#374151'
      }
    },
    checkbox: {
      marginRight: '8px'
    }
  };

  const MultiSelectDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPatterns, setSelectedPatterns] = useState(() => {
      try {
        return JSON.parse(localStorage.getItem('winningPattern') || '["any"]');
      } catch {
        return ['any'];
      }
    });
  
    const handlePatternSelect = (pattern) => {
      let newPatterns;
      if (pattern === 'any') {
        newPatterns = ['any'];
      } else {
        if (selectedPatterns.includes('any')) {
          newPatterns = [pattern];
        } else {
          newPatterns = selectedPatterns.includes(pattern)
            ? selectedPatterns.filter(p => p !== pattern)
            : [...selectedPatterns, pattern];
        }
        if (newPatterns.length === 0) {
          newPatterns = ['any'];
        }
      }
      setSelectedPatterns(newPatterns);
      localStorage.setItem('winningPattern', JSON.stringify(newPatterns));
      setWinningPattern(newPatterns); // Update parent state
    };
  
    return (
      <div className="relative">
        <label className="block text-white mb-2">Winning Patterns</label>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full p-2 bg-gray-700 text-white rounded flex justify-between items-center"
        >
          {selectedPatterns.includes('any') 
            ? 'Common Patterns' 
            : `Selected (${selectedPatterns.length})`}
          <span>▼</span>
        </button>
        {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-gray-700 rounded shadow-lg">
          <div 
            className="p-2 hover:bg-gray-600 cursor-pointer text-white"
            onClick={() => handlePatternSelect('any')}
          >
            Common Patterns
          </div>
          {Object.keys(winningPatterns).map(pattern => (
            <div
              key={pattern}
              className={`p-2 cursor-pointer text-white ${
                selectedPatterns.includes(pattern) ? 'bg-yellow-500' : 'hover:bg-gray-600'
              }`}
              onClick={() => handlePatternSelect(pattern)}
            >
              {pattern.replace(/([A-Z])/g, ' $1').trim()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [gameType, setGameType] = useState(localStorage.getItem('storedGameType') || 'regular');
  const [houseCardCount, setHouseCardCount] = useState(5);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [slideshowTables, setSlideshowTables] = useState([]);
  const [showHousePopup, setShowHousePopup] = useState(false);
  const [housePlayerCount, setHousePlayerCount] = useState(5);
  const urlPh = window.location.href;
  const url = window.location.href;
  const showVideo = urlPh.includes('pbingo') || urlPh.includes('local') || urlPh.includes('phoenix');

  const openInNewTab = (url) => {
    if (url.includes('power')) {
      const token = localStorage.getItem('token');
      const selectedNumbers = JSON.parse(localStorage.getItem('selectedNumbers') || '[]');
      const queryParams = new URLSearchParams({
        token: token,
        selectedNumbers: JSON.stringify(selectedNumbers)
      }).toString();
      url = `${url}?${queryParams}`;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    const storedGameType = localStorage.getItem('gameType');
    if (storedGameType) {
      setGameType(storedGameType);
    }
  }, []);

  const handleGameTypeSelect = (type) => {
    setGameType(type);
    localStorage.setItem('gameType', type);
  };


  const getApiUrl = () => {
    const hashedApiVersion = localStorage.getItem('apiVersion');
    if (hashedApiVersion) {
      const version2Hash = CryptoJS.SHA256('2').toString();
      if (hashedApiVersion === version2Hash) {
        return 'https://phoenix-bingo-2.onrender.com/api'
      }
    }
    return process.env.REACT_APP_API;
  };

  const API = getApiUrl();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);


  const winningPatterns = {
    rows: [
      [1, 2, 3, 4, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 6, 7, 8, 9, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 12, 13, 14, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 17, 18, 19, 20, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    columns: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 7, 0, 0, 0, 0, 12, 0, 0, 0, 0, 17, 0, 0, 0, 0, 22, 0, 0, 0],
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0],
      [0, 0, 0, 4, 0, 0, 0, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 19, 0, 0, 0, 0, 24, 0],
      [0, 0, 0, 0, 5, 0, 0, 0, 0, 10, 0, 0, 0, 0, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    diagonals: [
      [1, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 25],
      [0, 0, 0, 0, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    corners: [
      [1, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 25]
    ],
    surroundingFree: [
      [0, 0, 0, 0, 0, 0, 7, 0, 9, 0, 0, 0, 0, 0, 0, 0, 16, 0, 18, 0, 0, 0, 0, 0, 0]
    ],
    fullCard: [
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
    ],
    lShape: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    bothDiagonals: [
      [1, 0, 0, 0, 5, 0, 7, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 19, 0, 21, 0, 0, 0, 25]
    ],
    tShape: [
      [1, 2, 3, 4, 5, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    sevenShape: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    innerSquare: [
      [0, 0, 0, 0, 0, 0, 7, 8, 9, 0, 0, 11, 12, 13, 0, 0, 16, 17, 18, 0, 0, 0, 0, 0, 0]
    ],
    diamond: [
      [0, 0, 3, 0, 0, 0, 7, 0, 9, 0, 11, 0, 13, 0, 15, 0, 17, 0, 19, 0, 0, 0, 23, 0, 0]
    ],
    cPattern: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    numberFour: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    hShape: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 16, 0, 0, 0, 20, 21, 0, 0, 0, 25]
    ],
    cross: [
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 11, 12, 13, 14, 15, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    outerSquare: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 10, 11, 0, 0, 0, 15, 16, 0, 0, 0, 20, 21, 22, 23, 24, 25]
    ],
    zPattern: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 22, 23, 24, 25]
    ]
  };

  useEffect(() => {
    const selectedPatternTypes = Array.isArray(winningPattern) 
      ? winningPattern 
      : JSON.parse(localStorage.getItem('winningPattern') || '["any"]');
    let patternsToShow = [];
    
    if (selectedPatternTypes.includes('any')) {
      // If 'any' is selected, show only the common patterns
      const commonPatterns = ['rows', 'columns', 'diagonals', 'surroundingFree', 'corners'];
      patternsToShow = commonPatterns.map(key => winningPatterns[key][0]);
    } else {
      // Show only the specifically selected patterns
      selectedPatternTypes.forEach(patternType => {
        if (winningPatterns[patternType]) {
          patternsToShow = [...patternsToShow, ...winningPatterns[patternType]];
        }
      });
    }
    
    // Make sure we have at least one pattern
    if (patternsToShow.length === 0) {
      patternsToShow = [winningPatterns.rows[0]];
    }
    
    const tables = patternsToShow.map((pattern) => generateTable(pattern));
    setSlideshowTables(tables);
  }, [winningPattern]); 

  const handleNumberSelect = (number) => {
    if (selectedNumbers.includes(number)) {
      const updatedNumbers = selectedNumbers.filter((n) => n !== number);
      setSelectedNumbers(updatedNumbers);
      localStorage.setItem('selectedNumbers', JSON.stringify(updatedNumbers));
    } else {
      setSelectedNumbers([...selectedNumbers, number]);
      const updatedNumbers = [...selectedNumbers, number];
      setSelectedNumbers(updatedNumbers);
      localStorage.setItem('selectedNumbers', JSON.stringify(updatedNumbers));
    }
  };

  const ReloadIcon = ({ onClick }) => {
    return (
      <FaSync
        className="reload-icon"
        size={16}
        color="#fff"
        style={{ cursor: 'pointer' }}
        onClick={onClick}
      />
    );
  };

  const handleReloadNumbers = () => {
    const storedNumbers = localStorage.getItem('selectedNumbers');
    if (storedNumbers) {
      setSelectedNumbers(JSON.parse(storedNumbers));
    }
  };

  const handleStartGame = async () => {
    setIsLoading(true);
    try {  
      const response = await api.post(`${API}/game/start`, {
        bettingAmount: parseInt(bettingAmount),
        cardPaletteNumbers: selectedNumbers,
        callSpeed: parseInt(callSpeed),
        gameType: gameType,
        winningPatterns: JSON.parse(localStorage.getItem('winningPattern')),
        houseCardCount: gameType === 'house' ? parseInt(selectedNumbers.length) : undefined,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate('/game-in-progress2', { state: { gameId: response.gameId, calledNumbers: response.calledNumbers, playingCards: response.playingCards, payoutToWinner: response.payoutToWinner, callSpeed, audioLanguage, gameType, 
        houseCards: response.houseCards, callsToWin: response.winningCalls,  winningCalls: response.winningCalls,
        winningCard: response.winningCard,
        houseWin: response.houseWin } });
    } catch (error) {
      console.error('Error starting the game:', error);
      if (error.response.status === 400 && error.response.data.message == 'Insufficient balance in wallet') {
        alert('Insufficient balance in wallet');
      }
    }finally {
      setIsLoading(false);
    }
  };

  const handleLocalStorage = () => {
      localStorage.setItem('bettingAmount', bettingAmount);
      localStorage.setItem('callSpeed', callSpeed);
      localStorage.setItem('audioLanguage', audioLanguage);
      localStorage.setItem('winningPattern', JSON.stringify(winningPattern));
    };
  
    const generateTable = (pattern) => {
      const cellSize = 25;
      const dotSize = 25;

      const getPatternName = (pattern) => {
        const patternNames = {
          rows: 'Row',
          columns: 'Column',
          diagonals: 'Diagonal',
          surroundingFree: 'Surrounding FREE',
          corners: 'Four Corners',
          fullCard: 'Full House',
          lShape: 'L Shape',
          bothDiagonals: 'Both Diagonals',
          tShape: 'T Shape',
          sevenShape: 'Seven Shape',
          innerSquare: 'Inner Square',
          diamond: 'Diamond',
          cPattern: 'C Pattern',
          numberFour: 'Number Four',
          hShape: 'H Shape',
          cross: 'Cross',
          outerSquare: 'Outer Square',
          zPattern: 'Z Pattern'
        };
        for (const [key, patterns] of Object.entries(winningPatterns)) {
          if (patterns.some(p => JSON.stringify(p) === JSON.stringify(pattern))) {
            return patternNames[key] || key.replace(/([A-Z])/g, ' $1').toLowerCase().replace(/^./, str => str.toUpperCase());
          }
        }
        return '';
      };
    
      const cells = [];
      for (let i = 0; i < 25; i++) {
        cells.push(
          <td
            key={i}
            style={{
              padding: '15px 22px',
              position: 'relative',
              width: `${cellSize}px`,
              height: `${cellSize}px`,
              backgroundColor: '#E2E8F0',
              border: '1px solid black',
            }}
          >
            <div
              className='text-center mx-auto'
              style={{
                width: `${dotSize}px`,
                height: `${dotSize}px`,
                backgroundColor: pattern[i] > 0 ? 'blue' : 'transparent',
                borderRadius: '50%',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            ></div>
          </td>
        );
      }
  
      const rows = [];
      for (let i = 0; i < 5; i++) {
        rows.push(
          <tr key={i}>
            {cells.slice(i * 5, (i + 1) * 5)}
          </tr>
        );
      }
  
      const headerCells = ['B', 'I', 'N', 'G', 'O'].map((letter, index) => (
        <th
          key={index}
          className='fw-bold text-center'
          style={{
            backgroundColor: ['#3B82F6', '#EF4444', '#F97316', '#22C55E', '#ffc900'][index],
            width: `${cellSize}px`,
            height: `${cellSize}px`,
            fontSize: '20px',
            border: '1px solid white',
            padding: '10px',
          }}
        >
          {letter}
        </th>
      ));
  
      return (
        <div>
        <div className="text-center" style={{ color: 'yellow', fontSize: '20px' }}>
          {getPatternName(pattern)}
        </div>
        <table className='mb-0 pb-0' style={{ backgroundColor: '#E2E8F0', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{headerCells}</tr>
          </thead>
          <tbody className='mb-0 pb-0'>{rows}</tbody>
        </table>
        </div>
      );
    };
  

    const sliderContainerStyles = {
      width: '100%',
      maxWidth: '300px',
      margin: '0 auto',
      padding: '0 10px',
      boxSizing: 'border-box'
    };
  
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      arrows: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };
  

  const ProfileIcon = ({ onClick }) => {
    return (
      <div className='d-flex'>
      <div
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: '#ccc',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        <FaStar
        />
      </div>
      </div>
    );
  };

  const handleProfileClick = () => {
      navigate('/reports')
    };

  return (
    <div className="bg-gray-900 min-h-screen">
      <ToastContainer />
      <div className="flex justify-start pt-4 px-4">
        <ProfileIcon onClick={handleProfileClick} />
      </div>
      <BonusModal />
      <div className="container mx-auto px-4">
        {!window.location.href.includes('power') && (
            <div style={{ marginBottom: '2px', position: 'absolute', top: '10px', left: '10%', display: 'flex', alignItems: 'center' }}>
              <button
                onClick={() => handleGameTypeSelect('regular')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: gameType === 'regular' ? '#4CAF50' : '#ddd',
                  color: gameType === 'regular' ? 'white' : 'black',
                  border: 'none',
                  borderRadius: '5px',
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
              >
                Regular Bingo
              </button>
              <button
                onClick={() => handleGameTypeSelect('fast')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: gameType === 'fast' ? '#4CAF50' : '#ddd',
                  color: gameType === 'fast' ? 'white' : 'black',
                  border: 'none',
                  borderRadius: '5px',
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
              >
                Fast Bingo
              </button>
              <button
                onClick={() => handleGameTypeSelect('strategic-six-call')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: gameType === 'strategic-six-call' ? '#4CAF50' : '#ddd',
                  color: gameType === 'strategic-six-call' ? 'white' : 'black',
                  border: 'none',
                  borderRadius: '5px',
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
              >
                Super Fast Bingo
              </button>
              <button
                onClick={() => handleGameTypeSelect('house')}
                className={`house-button ${gameType === 'house' ? 'active' : ''}`}
              >
                Add Online Players ( x2 your win  )
                <span className="sparkle"></span>
                <span className="glow"></span>
              </button>
              <button
                onClick={() => navigate('/abazh')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: gameType === 'multiplier' ? '#4CAF50' : '#ddd',
                  color: gameType === 'multiplier' ? 'white' : 'black',
                  border: 'none',
                  borderRadius: '5px',
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
              >
                አባዥ Bingo (የተለያዩ የውርርድ መጠኖች)
              </button>
            </div>
          )}
        
        <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-9 bg-gray-800 p-4 rounded-lg">
            <div className="grid grid-cols-2 gap-4 text-white mb-4">
              <div>
                <label htmlFor="bettingAmount" className="block mb-2">
                  Bet Amount
                </label>
                <input
                  list="bettingAmountOptions"
                  className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg focus:outline-none"
                  value={bettingAmount}
                  onChange={(e) => setBettingAmount(e.target.value)}
                  placeholder="Select or type Bet Amount"
                  onBlur={handleLocalStorage}
                />
                <datalist id="bettingAmountOptions">
                  <option value="10"></option>
                  <option value="15"></option>
                  <option value="20"></option>
                  <option value="25"></option>
                  <option value="50"></option>
                  <option value="100"></option>
                  <option value="150"></option>
                  <option value="200"></option>
                </datalist>
              </div>
              <div>
                <MultiSelectDropdown />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="audioLanguage" className="block mb-2 text-white">
                  Audio Language
                </label>
                <select
                  id="audioLanguage"
                  className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg focus:outline-none"
                  value={audioLanguage}
                  onChange={(e) => setAudioLanguage(e.target.value)}
                  onBlur={handleLocalStorage}
                >
                  <option value="">select an option</option>
                  <option value="male">Amharic Male</option>
                  <option value="female">Amharic Female</option>
                  <option value="male">English Male</option>
                  <option value="female">English Female</option>
                  <option value="male">Tigrigna Male</option>
                  <option value="female">Tigrigna Female</option>
                </select>
              </div>
              <div>
                <label htmlFor="callSpeed" className="block mb-2 text-white">
                  Call Speed
                </label>
                <select
                  id="callSpeed"
                  className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg focus:outline-none"
                  value={callSpeed}
                  onChange={(e) => setCallSpeed(e.target.value)}
                  onBlur={handleLocalStorage}
                >
                  <option value="">Select Call Speed</option>
                  <option value="5000">5 seconds</option>
                  <option value="6000">6 seconds</option>
                  <option value="7000">7 seconds</option>
                  <option value="10000">10 seconds</option>
                  <option value="15000">15 seconds</option>
                </select>
              </div>
              <ReloadIcon onClick={handleReloadNumbers} className="text-success"/>
            </div>
            <div className="mt-4 border border-gray-600 rounded-lg overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-800">
              <div className="grid grid-cols-10 gap-2 p-2 text-xl">
                {Array.from({ length: 100 }, (_, i) => (
                  <button
                    key={i}
                    className={`px-2 py-1 rounded-md font-bold ${
                      selectedNumbers.includes(i + 1)
                        ? 'bg-yellow-600 text-white'
                        : 'text-gray-400'
                    }`}
                    onClick={() => handleNumberSelect(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="col-span-3">
          <div style={sliderContainerStyles}>
            {slideshowTables.length === 1 ? (
              <div className="single-pattern-container">
                {slideshowTables[0]}
              </div>
            ) : (
              <Slider {...settings}>
                {slideshowTables.map((table, index) => (
                  <div key={index} className="pattern-slide">
                    {table}
                  </div>
                ))}
              </Slider>
            )}
          </div>
            <button
              className="w-full py-3 bg-yellow-500 text-white font-bold rounded-lg hover:bg-yellow-600 focus:outline-none mt-auto"
              onClick={handleStartGame}
              disabled={!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading}
            >
              {isLoading ? 'Creating Game...' : 'Create Game'}
            </button>
          </div>
        </div>
      </div>
    </div>
    <NewGamesAnnouncementPopup />
    </div>
  );
}

export default DashboardPage;